module.exports = __webpack_public_path__ + "img/title.ebcf3713.png";